import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const Container = styled.div`
  ${tokens.text('body2')};
  color: ${tokens.color.text_default_inverse};
  background-color: ${tokens.color.neutral_800};
  border-radius: ${tokens.radius.m};
  ${tokens.elevation(1)};
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2};
  min-width: ${tokens.spacer.x2};
`;

export interface FeedbackSentimentGraphTooltipProps {
  value: number;
}

export function Tooltip({ value }: FeedbackSentimentGraphTooltipProps): JSX.Element {
  return <Container>{value}</Container>;
}
